import React from 'react';
import { Chat } from '../components/chat';

const ChatPage: React.FC = () => {
  return (
    <div className="h-full flex flex-col">
      <Chat />
    </div>
  );
};

export default ChatPage;
